export default function CalenderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_420_850)">
        <path
          d="M1.81377 12.0039H10.1871C11.0649 12.0039 11.7782 11.2906 11.7782 10.4128V2.48389C11.7782 1.60612 11.0649 0.892779 10.1871 0.892779H9.556V0.448342C9.556 0.203895 9.35598 0.00390625 9.11153 0.00390625C8.86708 0.00390625 8.66709 0.203895 8.66709 0.448342V0.892779H3.33378V0.448342C3.33378 0.203895 3.13376 0.00390625 2.88931 0.00390625C2.64486 0.00390625 2.44487 0.203895 2.44487 0.448342V0.892779H1.81377C0.935996 0.892779 0.222656 1.60612 0.222656 2.48389V10.4128C0.222656 11.2906 0.935996 12.0039 1.81377 12.0039ZM1.11157 2.48389C1.11157 2.09724 1.42712 1.78169 1.81377 1.78169H2.44487V2.22612C2.44487 2.47057 2.64486 2.67056 2.88931 2.67056C3.13376 2.67056 3.33375 2.47057 3.33375 2.22612V1.78169H8.66709V2.22612C8.66709 2.47057 8.86708 2.67056 9.11153 2.67056C9.35598 2.67056 9.55596 2.47057 9.55596 2.22612V1.78169H10.1871C10.5737 1.78169 10.8893 2.09724 10.8893 2.48389V3.78169H1.11157V2.48389ZM1.11157 4.67056H10.8893V10.4128C10.8893 10.7994 10.5738 11.115 10.1871 11.115H1.81377C1.42712 11.115 1.11157 10.7994 1.11157 10.4128V4.67056Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_420_850">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
